const teleport10Module = {
  id: "teleport10",
  name: "텔레포트(10)",
  description: "→10 텔레포트로 줄십(1×10) 자동 묶기",
  problem: { left: 6, right: 9 },
  steps: [
    {
      id: "tp10-1",
      instruction: '상단 표시등에서 "십"을 눌러 가로 10줄로 바꿔보세요!',
      hint: '오른쪽 끝 파란 "십" 표시등을 탭하세요',
      highlightArea: { type: "teleport-btn", buttonId: "row10" },
      validate: (state) => state.completed
    }
  ]
};
const teleport5Module = {
  id: "teleport5",
  name: "텔레포트(5)",
  description: "→5 텔레포트로 뚱십(2×5) 수동 묶기",
  problem: { left: 6, right: 7 },
  steps: [
    {
      id: "tp5-1",
      instruction: '표시등에서 "5"를 눌러 가로 5줄로 바꿔보세요!',
      hint: '상단 하늘색 "5" 표시등을 탭하세요',
      highlightArea: { type: "teleport-btn", buttonId: "row5" },
      validate: (state) => {
        var _a, _b;
        for (let c = 0; c < 10; c++) {
          for (let r = 6; r < 10; r++) {
            const st = (_b = (_a = state.mapGrid[c]) == null ? void 0 : _a[r]) == null ? void 0 : _b.state;
            if (st === "on" || st === "done") return true;
          }
        }
        return false;
      }
    },
    {
      id: "tp5-2",
      instruction: "2줄×5칸을 드래그해서 10개 묶음을 만들어요!",
      hint: "위 2줄, 왼쪽 5칸을 드래그하세요",
      highlightArea: { type: "map", startCol: 0, startRow: 0, endCol: 4, endRow: 1 },
      validate: (state) => state.fullCount >= 10
    },
    {
      id: "tp5-3",
      instruction: "잘했어요! 나머지도 같은 방법으로 묶어보세요!",
      hint: "다음 2줄×5칸을 드래그하세요",
      validate: (state) => state.completed
    }
  ]
};
const fatTieModule = {
  id: "fatTie",
  name: "뚱십 묶기",
  description: "텔레포트 없이 2×5/5×2 직접 묶기",
  problem: { left: 7, right: 4 },
  steps: [
    {
      id: "fat-1",
      instruction: "5줄×2칸을 드래그해서 10개 묶음을 만들어요!",
      hint: "위 5줄, 왼쪽 2칸을 세로로 드래그하세요",
      highlightArea: { type: "map", startCol: 0, startRow: 0, endCol: 1, endRow: 4 },
      validate: (state) => state.fullCount >= 10
    },
    {
      id: "fat-2",
      instruction: "잘했어요! 나머지도 같은 방법으로 묶어보세요!",
      hint: "5줄×2칸 또는 2줄×5칸을 드래그하세요",
      validate: (state) => state.completed
    }
  ]
};
function calcBankStrategy(problem) {
  const { left, right } = problem;
  const total = left * right;
  const hNeeded = right < 10 ? left * (10 - right) : Infinity;
  const vNeeded = left < 10 ? right * (10 - left) : Infinity;
  const hValid = isFinite(hNeeded) && hNeeded > 0 && hNeeded <= 11;
  const vValid = isFinite(vNeeded) && vNeeded > 0 && vNeeded <= 11;
  if (!hValid && !vValid) return null;
  const useH = hValid && (!vValid || hNeeded <= vNeeded);
  if (useH) {
    return {
      axis: "horizontal",
      needed: hNeeded,
      perLine: 10 - right,
      // 행마다 추가할 개수
      tieCount: left - 1,
      // 묶을 줄 수 (마지막 행은 반납용)
      loose: 10 - hNeeded,
      // 마지막 행 반납 후 남는 낱개
      total
    };
  }
  return {
    axis: "vertical",
    needed: vNeeded,
    perLine: 10 - left,
    // 열마다 추가할 개수
    tieCount: right - 1,
    // 묶을 줄 수 (마지막 열은 반납용)
    loose: 10 - vNeeded,
    // 마지막 열 반납 후 남는 낱개
    total
  };
}
function createBankModule(problem = { left: 7, right: 3 }) {
  const strategy = calcBankStrategy(problem);
  const total = problem.left * problem.right;
  if (!strategy) {
    return {
      id: "bank",
      name: "은행",
      description: `${problem.left}×${problem.right}=${total} — 은행 사용 불가 (필요 개수 > 11)`,
      problem,
      steps: [
        {
          id: "bank-na",
          instruction: `${problem.left}×${problem.right}=${total}은 10으로 확장하려면 은행(최대 11개)이 부족합니다. 다른 방법을 사용하세요.`,
          hint: "뚱십 또는 텔레포트를 사용해보세요",
          validate: () => false
        }
      ]
    };
  }
  const { axis, needed } = strategy;
  const isH = axis === "horizontal";
  const lineLabel = isH ? "행" : "열";
  const targetLabel = isH ? "가로" : "세로";
  return {
    id: "bank",
    name: "은행",
    description: `${problem.left}×${problem.right}=${total} — 은행 ${needed}개로 ${targetLabel} 10 확장`,
    problem,
    steps: [
      {
        id: "bank-1",
        instruction: `은행에서 ${needed}개를 꺼내보세요!`,
        hint: `은행 영역에서 ${needed}개를 드래그하세요`,
        highlightArea: { type: "bank", startCol: 0, startRow: 0, endCol: 3, endRow: 2 },
        validate: (state) => {
          var _a, _b, _c, _d;
          for (let c = 0; c < 4; c++) {
            for (let r = 0; r < 3; r++) {
              if ((_b = (_a = state.bankGrid[c]) == null ? void 0 : _a[r]) == null ? void 0 : _b.isEmpty) continue;
              const st = (_d = (_c = state.bankGrid[c]) == null ? void 0 : _c[r]) == null ? void 0 : _d.state;
              if (st === "select" || st === "off") return true;
            }
          }
          return false;
        }
      },
      {
        id: "bank-2",
        instruction: `빈칸에 인형을 놓아 ${targetLabel} 10칸으로 만드세요!`,
        hint: "그리드의 빈칸을 드래그하세요",
        highlightArea: { type: "map" },
        validate: (state) => {
          var _a, _b, _c, _d;
          for (let c = 0; c < 4; c++) {
            for (let r = 0; r < 3; r++) {
              if ((_b = (_a = state.bankGrid[c]) == null ? void 0 : _a[r]) == null ? void 0 : _b.isEmpty) continue;
              if (((_d = (_c = state.bankGrid[c]) == null ? void 0 : _c[r]) == null ? void 0 : _d.state) === "off") return true;
            }
          }
          return false;
        }
      },
      {
        id: "bank-3",
        instruction: `마지막 ${lineLabel}에서 ${needed}개를 은행에 돌려주세요!`,
        hint: `마지막 ${lineLabel}의 인형을 드래그하세요`,
        highlightArea: { type: "bank" },
        validate: (state) => {
          var _a, _b, _c, _d;
          for (let c = 0; c < 4; c++) {
            for (let r = 0; r < 3; r++) {
              if ((_b = (_a = state.bankGrid[c]) == null ? void 0 : _a[r]) == null ? void 0 : _b.isEmpty) continue;
              const st = (_d = (_c = state.bankGrid[c]) == null ? void 0 : _c[r]) == null ? void 0 : _d.state;
              if (st === "off" || st === "select") return false;
            }
          }
          return true;
        }
      },
      {
        id: "bank-4",
        instruction: `잘했어요! 10개씩 묶어보세요!`,
        hint: `${isH ? "가로" : "세로"} 10개를 드래그하세요`,
        validate: (state) => state.completed
      }
    ]
  };
}
const bankModule = createBankModule({ left: 7, right: 3 });
const MODULE_REGISTRY = {
  teleport10: teleport10Module,
  teleport5: teleport5Module,
  fatTie: fatTieModule,
  bank: bankModule
};
function resolveTutorialModules(ids, problem) {
  return ids.map((id) => {
    if (id === "bank" && problem) return createBankModule(problem);
    return MODULE_REGISTRY[id];
  }).filter(Boolean);
}
const ALL_TUTORIAL_MODULES = [
  { id: "teleport10", name: "텔레포트(10)", description: "→10 + 줄십 자동 묶기" },
  { id: "teleport5", name: "텔레포트(5)", description: "→5 + 뚱십 수동 묶기" },
  { id: "fatTie", name: "뚱십 묶기", description: "2×5/5×2 직접 묶기" },
  { id: "bank", name: "은행", description: "빌리기/놓기/반납 후 묶기" }
];
export {
  ALL_TUTORIAL_MODULES,
  calcBankStrategy,
  createBankModule,
  resolveTutorialModules
};
//# sourceMappingURL=tutorial.js.map
